import api from '@/api'
import axios from 'axios'
import firebaseConfig from '@/api/firebase-config'
import { generateRandomString } from '@/api/utils'

export const dataURLtoFile = (dataurl) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  const fileName = generateRandomString(10)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], fileName, { type: mime })
}

export const uploadFile = async (file, path) => {
  const fileName = `${path}/${generateRandomString(10)}`
  const fileType = file.type.split(';')[0]
  const uploadedUrl = `https://storage.googleapis.com/${firebaseConfig.projectId}-images/${fileName}`
  const { signUrl } = await getSignUrl(fileName, fileType)
  await uploadToGcp(signUrl, file, fileType)
  return uploadedUrl
}

// login or signup before use the api
export const getSignUrl = async (fileName, fileType) => {
  const method = 'get'
  const urlEnd = `/v2/credential/gcsSignUrl?fileName=${fileName}&contentType=${fileType}`
  const response = await api.asyncRequest(urlEnd, method)
  if (response.ok) return response.data
  else return Promise.reject(response.data)
}

const uploadToGcp = async (url, file, fileType) => {
  await axios.put(url, file, {
    headers: { 'content-type': fileType }
  })
}
